import { render, staticRenderFns } from "./CoursewareRejected.vue?vue&type=template&id=2a0309a2"
import script from "./CoursewareRejected.vue?vue&type=script&lang=js"
export * from "./CoursewareRejected.vue?vue&type=script&lang=js"
import style0 from "./CoursewareRejected.vue?vue&type=style&index=0&id=2a0309a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports